import React from "react";

const Social = () => {
	return (
		<div className='home__social'>
			<a
				href='https://www.linkedin.com/in/naga-vamsi-reddy-satti/'
				className='home__social-icon'
				target='_blank'
				rel='noopener noreferrer'>
				<i class='uil uil-linkedin-alt'></i>
			</a>

			<a
				href='https://github.com/vamsireddy99126'
				className='home__social-icon'
				target='_blank'
				rel='noopener noreferrer'>
				<i class='uil uil-github-alt'></i>
			</a>
		</div>
	);
};

export default Social;
